// Lightweight GA4 (gtag.js) loader.
// Reads the GA4 Measurement ID from VITE_GA4_MEASUREMENT_ID (format: G-XXXXXXXXXX).
// Once initialized, window.gtag is available and the web-vitals reporter will
// automatically forward LCP, INP, CLS, FCP and TTFB events to GA4.

const GA4_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID as string | undefined;

let initialized = false;

export function initGA4() {
  if (initialized) return;
  if (typeof window === "undefined") return;
  if (!GA4_ID || !/^G-[A-Z0-9]+$/i.test(GA4_ID)) {
    console.info(
      "[GA4] VITE_GA4_MEASUREMENT_ID not set — skipping GA4 init. Web Vitals will still log to console."
    );
    return;
  }

  // gtag stub
  const w = window as any;
  w.dataLayer = w.dataLayer || [];
  function gtag(...args: any[]) {
    w.dataLayer.push(args);
  }
  w.gtag = w.gtag || gtag;
  w.gtag("js", new Date());
  w.gtag("config", GA4_ID, {
    send_page_view: true,
    transport_type: "beacon",
  });

  // Inject gtag.js
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA4_ID}`;
  document.head.appendChild(script);

  initialized = true;
}
